import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce03897c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-top" }, null, -1))
const _hoisted_3 = { class: "login-main" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-desc" }, "雷克萨斯电气化经营管理系统", -1))
const _hoisted_5 = ["data-bid"]
const _hoisted_6 = { class: "login-bottom" }
const _hoisted_7 = { class: "login-bottom__content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "login-bottom__content" }, " 粤ICP备15082797号 增值电信业务经营许可证：粤B2-20210668 联网备案号 44030602007104号 客服电话：400 628 0808 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleGotoWeiXinAuth && _ctx.handleGotoWeiXinAuth(...args))),
        "data-bid": _ctx.btns.LoginBtn.id,
        class: "login-submit"
      }, _toDisplayString(_ctx.btns.LoginBtn.name), 9, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("p", _hoisted_7, _toDisplayString(`Copyright © 2016-${new Date().getFullYear()} 深圳市立新出行信息技术有限公司版权所有`), 1),
      _hoisted_8
    ])
  ]))
}